import "../../styles/footer.css";

export const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-services">
        <div className="wrapper">
          <a
            href="https://www.realme.com/in/legal/terms-sales"
            className="footer-service"
          >
            <span className="icon icon-s-freeshipping"></span>
            <span>Free shipping</span>
          </a>
          <a
            href="https://www.realme.com/in/legal/terms-sales"
            className="footer-service"
          >
            <span className="icon icon-s-payment"></span>
            <span>Secure payment</span>
          </a>
          <a
            href="https://www.realme.com/in/legal/terms-sales"
            className="footer-service"
          >
            <span className="icon icon-s-cod"></span>
            <span>Cash On Delivery</span>
          </a>
          <a
            href="https://www.realme.com/in/legal/warranty-terms"
            className="footer-service"
          >
            <span className="icon icon-s-online"></span>
            <span>Warranty Policy</span>
          </a>
        </div>
      </div>
      <div className="footer-center">
        <div className="footer-menus">
          <div className="wrapper">
            <div className="footer-menu">
              <div className="footer-menu-title">
                Recommended<span className="icon icon-arrow-down"></span>
              </div>
              <ul className="footer-menu-list">
                <li>
                  <a className="gtag" href="https://buy.realme.com/in/goods/404">realme narzo 50A</a>
                </li>

                <li>
                  <a className="gtag" href="https://buy.realme.com/in/goods/418">realme narzo 50i</a>
                </li>

                <li>
                  <a className="gtag" href="https://buy.realme.com/in/goods/391">realme 8s 5G</a>
                </li>

                <li>
                  <a className="gtag" href="https://buy.realme.com/in/goods/390">realme 8i</a>
                </li>

                <li>
                  <a className="gtag" href="https://buy.realme.com/in/goods/395">realme GT 5G</a>
                </li>

                <li>
                  <a className="gtag" href="https://buy.realme.com/in/goods/393?id=966">realme GT Master Edition</a>
                </li>

                <li>
                  <a className="gtag" href="https://buy.realme.com/in/goods/423">realme C25Y</a>
                </li>

                <li>
                  <a className="gtag" href="https://buy.realme.com/in/goods/359?id=898">realme X7 Max 5G</a>
                </li>
              </ul>
            </div>

            <div className="footer-menu">
              <div className="footer-menu-title">
                Support<span className="icon icon-arrow-down"></span>
              </div>
              <ul className="footer-menu-list">
                <li>
                  <a className="gtag" href="https://www.realme.com/in/support/faq">FAQ</a>
                </li>

                <li>
                  <a className="gtag" href="https://www.realme.com/in/support/troubleshooting">Troubleshooting</a>
                </li>

                <li>
                  <a className="gtag" href="https://www.realme.com/in/support#user-guid">User Guide</a>
                </li>

                <li>
                  <a className="gtag" href="https://www.realme.com/in/support/services">Service Centers</a>
                </li>

                <li>
                  <a className="gtag" href="https://www.realme.com/in/legal/coins">realme Coins</a>
                </li>

                <li>
                  <a className="gtag" href="https://www.realme.com/in/legal/e-waste-management">E-waste Management</a>
                </li>
              </ul>
            </div>
            <div className="notResDiv">
              <div className="footer-menu">
                <div className="footer-menu-title">
                  About realme<span className="icon icon-arrow-down"></span>
                </div>
                <ul className="footer-menu-list">
                  <li>
                    <a className="gtag" href="https://www.realme.com/in/brand">Our Brand</a>
                  </li>

                  <li>
                    <a className="gtag" href="https://www.realme.com/in/brand/newsroom">Newsroom</a>
                  </li>

                  <li>
                    <a className="gtag" href="https://www.realme.com/in/store-address">Retail Store</a>
                  </li>

                  <li>
                    <a className="gtag" href="https://www.realme.com/in/bulk-order">Bulk Order</a>
                  </li>

                  <li>
                    <a className="gtag" href="https://www.realme.com/in/legal/declaration">Declaration</a>
                  </li>
                </ul>
              </div>

              <div className="footer-menu">
                <div className="footer-menu-title">
                  Contact realme<span className="icon icon-arrow-down"></span>
                </div>
                <ul className="footer-menu-list">
                  <li>
                    <a className="gtag" href="mailto:service@realme.com">service@realme.com</a>
                  </li>

                  <li>
                    <a className="gtag" href="mailto:orders.in@realme.com">orders.in@realme.com </a>
                  </li>
                </ul>
              </div>
            
          </div>
          <div className="footer-contact">
            <div className="footer-contact-phone">
              <a href="tel:18001022777">1800 102 2777</a>
            </div>
            <div className="footer-contact-time">
              9:00-21:00, MON-SUN <br /> Including Holidays
            </div>

            <div className="footer-contact-online">
              <a href="https://www.facebook.com/realmeIndia/" >
                <span className="icon icon-chat"></span>CHAT SUPPORT
              </a>
            </div>

            <div className="footer-contact-time">
              9:00-21:00, MON-SUN <br /> Including Holidays
            </div>
            <div className="footer-socials">
              <a className="footer-social" href="https://www.facebook.com/realmeIndia/">
                <span className="icon icon-facebook"></span>
              </a>
              <a className="footer-social" href="https://twitter.com/realmeIndia">
                <span className="icon icon-twitter"></span>
              </a>
              <a className="footer-social" href="https://www.youtube.com/realmemobiles">
                <span className="icon icon-youtube"></span>
              </a>
              <a className="footer-social" href="https://www.instagram.com/realmeindia/">
                <span className="icon icon-instagram"></span>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-region">
          <a href="https://www.facebook.com/realmeIndia" >India ( English / INR )</a>
        </div>
        <div className="footer-bottom">
          <div className="wrapper">
            <div className="copyright">
              © 2018-2022 realme. All Rights Reserved.
            </div>
            </div>
            <div className="footer-legal">
              <a href="https://www.realme.com/in/legal/user-agreement" title="User Agreement">
                User Agreement
              </a>
              <a href="https://www.realme.com/in/legal/privacy-policy" title="Privacy Policy">
                Privacy Policy
              </a>
              <a href="https://www.realme.com/in/legal/terms-sales" title="Terms of Sales">
                Terms of Sales
              </a>
              <a href="https://www.realme.com/in/legal/warranty-terms" title="Warranty Terms">
                Warranty Terms
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};